import $ from 'jquery';

export const init = () => {
	if ($('html').hasClass('no-objectfit')) {
		function checkImg(params) {
			$('.no-objectfit .js-objectfit').each(function (index, el) {
				var $container = $(this),
					imgUrl = $container.find('img').prop('src');
				if (imgUrl) {
					el.setAttribute('style', `background-image: url("${imgUrl}")`);
					el.classList.add('object-fit-bg');
				}
			});
		}
		setTimeout(() => {
			checkImg();
		}, 500);
		$(window).on('resize', checkImg);
	}
};
